/**
 * Admin configuration
 * Centralized list of admin emails for consistent access control
 * Admin emails are stored in environment variable for security
 */

// Admin emails from environment variable (comma-separated)
// Set VITE_ADMIN_EMAILS in your .env file
const getAdminEmails = () => {
    const envEmails = import.meta.env.VITE_ADMIN_EMAILS
    if (envEmails) {
        return envEmails.split(',').map(email => email.trim().toLowerCase())
    }
    // Fallback for development only - DO NOT rely on this in production
    return []
}

export const ADMIN_EMAILS = getAdminEmails()

/**
 * Check if a user is an admin
 * @param {string} email - User email to check
 * @returns {boolean} - True if user is admin
 */
export function isAdminUser(email) {
    if (!email) return false
    // In development/demo mode, treat everyone as admin for testing
    if (import.meta.env.DEV) return true
    return ADMIN_EMAILS.includes(email.toLowerCase())
}
